var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.41,
    height: 42.378,
    viewBox: "0 0 42.41 42.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gender",
    transform: "translate(-5458.217 -1465.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M5500.627,1466.471v7.965a1.123,1.123,0,0,0-.057.1.85.85,0,0,1-.939.51.832.832,0,0,1-.666-.871c-.006-.99,0-1.98,0-2.971v-2.546l-8.765,8.573.239.307a10.924,10.924,0,0,1-15.653,15.114,10.788,10.788,0,0,1-2.557-13.328,5.221,5.221,0,0,1,1.29,1.062.74.74,0,0,1-.028.069,8.871,8.871,0,0,0,.515,8.749,9.273,9.273,0,1,0,15.272-10.475,9.093,9.093,0,0,0-6.247-3.572,11.6,11.6,0,0,0-1.817.007l-.044,0c-.279.016-.557.032-.848.037l-.052,0c-.435-.449-.862-.906-1.286-1.36a10.635,10.635,0,0,1,9.735,1.982l.3.234,8.786-8.594h-5.469a.885.885,0,0,1-.955-.67c-.092-.388.116-.73.591-.967.017-.009.032-.019.048-.029h7.936A.6.6,0,0,1,5500.627,1466.471Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M5474.2,1501.357c-.542,0-1.083,0-1.625,0h-1.666c-.1,0-.2-.006-.3-.011l-.527-.028v-5.977l2.028-.463c-.463-.5-.857-.916-1.264-1.331-.033,0-.068,0-.106,0-.356,0-.664.015-.971.03a9.767,9.767,0,0,1-2-.041,9.282,9.282,0,1,1,9.835-5.219l0,.036c.352.3.745.629,1.151.965l.117.1a10.606,10.606,0,0,0,.95-7.755,11.184,11.184,0,0,0-5.249-6.849,10.931,10.931,0,0,0-15.258,4.859,10.447,10.447,0,0,0-.263,8.736,10.936,10.936,0,0,0,8.94,6.834l.364.059v6.055l-1.581,0c-.87,0-1.731,0-2.593.006a.866.866,0,0,0-.765.441.8.8,0,0,0,.03.817.848.848,0,0,0,.8.406l1.535,0,2.606,0v4.138c0,.619.315,1.007.825,1.012a.77.77,0,0,0,.558-.208,1.142,1.142,0,0,0,.281-.822v-4.121h1.59c.868,0,1.713,0,2.56,0a.835.835,0,1,0,0-1.663Z",
    fill: "#6291f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.f2087cb196f8284e46fa9dd1cc1891ed.svg";
export { ForwardRef as ReactComponent };